import { ViewTab } from '../types';

// URL dédiée pour chaque ViewTab - conforme aux labels sidebar / titres pages
export const TAB_TO_PATH: Record<ViewTab, string> = {
  dashboard: '/dashboard',
  discussions: '/discussions',
  inbox: '/inbox',
  interventions: '/interventions',
  whatsapp: '/whatsapp',
  whatsapp_connect: '/whatsapp/connect',
  account_manage: '/whatsapp/manage',
  campaigns: '/campaigns',
  create_campaign: '/campaigns/new',
  clients: '/contacts',
  agent: '/agent',
  knowledge: '/knowledge',
  import_knowledge: '/knowledge/import',
  knowledge_guide: '/knowledge/guide',
  settings: '/settings',
  two_fa_setup: '/settings/2fa',
  pricing: '/pricing',
  billing: '/billing',
  recharge: '/recharge',
  landing: '/',
  appointments: '/appointments',
  operations: '/operations',
  tutorial: '/support',
  support: '/support',
  partenariat: '/partenariat',
  partner_dashboard: '/settings/partner',
  blog: '/blog',
};

// Inverser pour parser l'URL -> ViewTab
export const PATH_TO_TAB: Record<string, ViewTab> = Object.fromEntries(
  Object.entries(TAB_TO_PATH).map(([tab, path]) => [path, tab as ViewTab])
) as Record<string, ViewTab>;

// Aliases rétrocompatibilité (anciennes URLs restent valides)
export const PATH_ALIASES: Record<string, ViewTab> = {
  '/landing': 'landing',
  '/overview': 'dashboard',
  '/validations': 'interventions',
  '/interventions': 'interventions',
  '/inbox': 'inbox',
  '/clients': 'clients',
  '/contacts': 'clients',
  '/catalogue': 'knowledge',
  '/catalog': 'knowledge',
  '/pricing': 'pricing',
  '/agent-config': 'agent',
  '/campaigns/new': 'create_campaign',
  '/whatsapp/manage': 'account_manage',
  '/accounts/manage': 'account_manage',
  '/whatsapp/connect': 'whatsapp_connect',
  '/settings/2fa': 'two_fa_setup',
  '/knowledge/import': 'import_knowledge',
  '/knowledge/guide': 'knowledge_guide',
  '/tutorial': 'support',
  '/tutoriel': 'support',
  '/guide': 'support',
  '/aide': 'support',
  '/help': 'support',
  '/partenariat': 'partenariat',
  '/partenaires': 'partenariat',
  '/partners': 'partenariat',
  '/affiliation': 'partenariat',
  '/articles': 'blog',
  '/settings/partner': 'partner_dashboard',
  '/settings/partenaire': 'partner_dashboard',
  '/partner': 'partner_dashboard',
  '/partenaire': 'partner_dashboard',
  '/partner/dashboard': 'partner_dashboard',
  '/partenaire/dashboard': 'partner_dashboard',
};

// Normalise pathname -> ViewTab (gère trailing slash, alias, inconnu -> dashboard)
export function pathToViewTab(pathname: string): ViewTab {
  const clean = pathname.replace(/\/+$/, '') || '/';
  if (PATH_TO_TAB[clean]) return PATH_TO_TAB[clean];
  if (PATH_ALIASES[clean]) return PATH_ALIASES[clean];
  // fallback: tente sans trailing slash
  return 'dashboard';
}

export const ALL_PATHS = Object.values(TAB_TO_PATH);
